import { FC, PropsWithChildren } from "react";

const SubTitle: FC<PropsWithChildren> = ({ children }) => (
  <div className="text-[16px] font-bold">
    {children}
  </div>
);

export default SubTitle;
